import { render } from "./StartModalSide.vue?vue&type=template&id=0bef8111&scoped=true"
import script from "./StartModalSide.vue?vue&type=script&lang=js"
export * from "./StartModalSide.vue?vue&type=script&lang=js"

import "./StartModalSide.vue?vue&type=style&index=0&id=0bef8111&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bef8111"]])

export default __exports__